import { isLocalhost } from "util/index";

import { serializeError } from "serialize-error";
import { eNAEPComponents, ServiceWorkerType } from "../Types/AppStateTypes";
export type ServiceWorkerRegResponse = {
  registrations?: "Completed" | "Unsupported",
  error?: any
}
export function serviceWorkerRegistration(){
// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA
const logPrefix= "[ADPServiceWorker]"

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
  scope?: string;
  appName: eNAEPComponents
};

 function getConfig(appName: eNAEPComponents, scope?: string) {
  const config = {
    scope,
    appName,
    onSuccess : (registration:ServiceWorkerRegistration)=>{
      console.log(`[${appName}][serviceWorker] Service Worker Loaded`);
      
    },
    onUpdate:(registration:ServiceWorkerRegistration)=>{
      console.log(`[${appName}][serviceWorker] Update Found,notify client`,registration);
      registration?.waiting?.postMessage({type: 'SKIP_WAITING'});
    }
  }
  return config;
} 

 async function registerSW():Promise<ServiceWorkerRegResponse | undefined> {
  let registrationStatus: ServiceWorkerRegResponse | undefined= undefined;
  if ('serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    console.log({publicUrl},window.location.origin)
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      registrationStatus = {error: `Unsupported Origin ${window.location.origin}`};
    }
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      const adcSwUrl = `${self.location.origin}/ade/service-worker.js`;
      const sciSwUrl = `${self.location.origin}/login/service-worker.js`;

      if (isLocalhost()) {
        return new Promise<ServiceWorkerRegResponse>(function (resolve) { 
           // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, getConfig(eNAEPComponents.ADP));
        navigator.serviceWorker.ready.then(() => {
          console.log(logPrefix,
            'This web app is being served cache-first by a service ' +
              'worker. To learn more, visit https://cra.link/PWA'
          );
          registrationStatus = {registrations: "Completed"}
          resolve ({registrations: "Completed"})
        }).catch((e)=>{
          const error = serializeError(e);
          console.error({error})
          registrationStatus = {error:error}
          resolve ({error:error})
        })
        resolve ({registrations: "Completed"})
        })
       
      } else {
        async function _registerAllSW(){
          return new Promise<ServiceWorkerRegResponse>(function (resolve) { 
            let promises = [];
            if(isLocalhost()){
              resolve ({registrations: "Completed"})
            }
            else if (window?.location.hostname.includes("127.0.0")){
              const adpPromise = registerValidSW(swUrl, getConfig(eNAEPComponents.ADP));
              promises.push(adpPromise)
            }
            else {
            const adpPromise = registerValidSW(swUrl, getConfig(eNAEPComponents.ADP));
            const adcPromise = registerValidSW(adcSwUrl, getConfig(eNAEPComponents.ADC, '/'));
            const sciPromise = registerValidSW(sciSwUrl, getConfig(eNAEPComponents.SCI, '/login/'))
              promises.push(adpPromise,adcPromise,sciPromise);
            }
            Promise.all(promises).then((registrations)=>{
              resolve ({registrations: "Completed"})
            }).catch((e)=>{
              const error = serializeError(e);
              console.error({error})
              resolve ({error:error})
            });
              })
            }
            registrationStatus = await _registerAllSW();
      }
      return registrationStatus
  }
  else {
    return {registrations: "Unsupported"}
  }
}

function registerValidSW(swUrl: string, config: Config) {
    return new Promise<boolean>(function (resolve,reject) {
       // console.group(logPrefix,"RegisterVaidSW", swUrl);
        navigator.serviceWorker
          .register(swUrl, { updateViaCache: 'none', scope: config?.scope })
          .then((registration) => {
            if (registration.installing) {
              console.log(logPrefix,"[RegisterVaidSW] installing", config?.scope, registration.installing);
            } else if (registration.waiting) {
              console.log(logPrefix,"[RegisterVaidSW] waiting",  config?.scope, registration.waiting);
            } else if (registration.active) {
              console.log(logPrefix,"[RegisterVaidSW] active",  config?.scope, registration.active);
              resolve(true);
            }
            registration.onupdatefound = () => {
              const installingWorker = registration.installing;
              if (installingWorker == null) {
                return;
              }
              installingWorker.onstatechange = () => {
                  const serviceWorkerDetails: ServiceWorkerType = {
                      appCode: config.appName,
                      registrationStatus: installingWorker.state
                    }
                  //  dispatch(actions.createUpdateServiceWorkerDetailsAction(serviceWorkerDetails));
                }
              if (installingWorker.state === 'installed') {
                  if (navigator.serviceWorker.controller) {
                    if (config && config.onUpdate) {
                      config.onUpdate(registration);
                    }
                  } else {
                    console.log(logPrefix,'Content is cached for offline use.', swUrl);
                    if (config && config.onSuccess) {
                      config.onSuccess(registration);
                  }
                };
              };
              resolve(true);
            };
          }).catch((error) => {
            console.error(logPrefix,'Error during service worker registration:', error);
            const serviceWorkerDetails: ServiceWorkerType = {
              appCode: config.appName,
              registrationStatus: "Error during service worker registration"
            }
            reject(error);
          });
         // console.groupEnd();
    });
}

function checkValidServiceWorker(swUrl: string, config: Config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration) => {
          console.log(logPrefix,"serviceWorker.ready, installing",registration.installing?.scriptURL)
          // window.location.reload();
         /*  registration.unregister().then(() => {
            console.log("[ServiceWorker] unregistered")
          }); */
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(logPrefix,'No internet connection found. App is running in offline mode.');
    });
}
return {registerSW}
}
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}